<template>
<div class="animated fadeIn">
  <resize-observer @notify="handleResize" />
  <!--[start] Reach Simulation 헤더 -->
  <b-card class="bs-callout bs-callout-primary panelScrollBar" style="height:100px;margin-bottom:12px;">
    <b-row style="min-width: 1200px;">
      <b-col sm="3">
        <div style="margin-top:-7px;">
          <span class="card-title wise-card-header">리치 시뮬레이션 (DA)</span>
        </div>
        <div class="wise-small-header">Reach Simulation</div>
      </b-col>
      <b-col sm="4" class="brief">
        <div class="wise-small-header">캠페인 타이틀</div>
        <b-form-input class="no-border" :class="{error: errors.has('campaignTitle')}" name="campaignTitle" v-validate="'required|min:2'" v-model="formData.campaignTitle" type="text" placeholder="캠페인 타이틀을 입력하세요"></b-form-input>
      </b-col>
      <b-col sm="2" class="brief">
        <div class="wise-small-header">총 예산 (만원)</div>
        <b-form-input class="no-border" style="background:#fff" v-validate="'required'" min=0 v-model="formData.totalBudgetStr" :formatter="format_thousands"  type="text" placeholder="총예산을 입력하세요" readonly></b-form-input>
      </b-col>
      <b-col sm="3" class="brief">
        <div class="wise-small-header">캠페인 기간</div>
        <b-form-input class="no-border" type="text" name="daterange" />
      </b-col>
    </b-row>
  </b-card>
  <!--[end] Reach Simulation 헤더 -->
  <!--[start] 캠페인 기본 정보 입력 -->
  <b-card class="bs-callout bs-callout-primary panelScrollBar" style="height:180px;margin-bottom:12px;">
    <div style="min-width: 1200px;">
      <b-row style="padding-bottom:35px;">
        <b-col sm="12">
          <span class="card-title wise-card-title">1. 캠페인 기본 정보 입력</span>
          <span class="small text-muted wise-card-subtitle"> 캠페인의 <b>기본정보</b>를 <b>입력</b>하세요.</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="2" class="wise-small-header wise-small-header2" style="">타이틀</b-col>
              <b-col sm="10" style="padding-left:0px">
                <b-form-input class="no-border" :class="{error: errors.has('simulationTitle')}" name="simulationTitle" v-validate="'required|min:2'" v-model="formData.simulationTitle" type="text" placeholder="시뮬레이션 타이틀을 입력하세요 "></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="2">
          <div class="input-bottom-line" v-on:click="advertigerModal = true">
            <b-row>
              <b-col sm="4" class="wise-small-header wise-small-header2">광고주</b-col>
              <b-col sm="8" style="padding-left:0px;">
                <input class="form-control no-border" :class="{error: errors.has('advertiger')}" name="advertiger" v-validate="'required|min:2'" v-model="advertigerName" type="text" placeholder="광고주를 선택하세요" v-on:focus="advertigerModal = true"></input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="2">
          <div class="input-bottom-line" v-on:click="agencyModal = true">
            <b-row>
              <b-col sm="4" class="wise-small-header wise-small-header2">대행사</b-col>
              <b-col sm="8" style="padding-left:0px;">
                <input class="form-control no-border" :class="{error: errors.has('agency')}" name="agency" v-validate="'required|min:2'" v-model="agencyName" type="text" placeholder="대행사를 선택하세요" v-on:focus="agencyModal = true"></input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="3">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="3" class="wise-small-header wise-small-header2">업종</b-col>
              <b-col sm="9" style="padding-left:0px;">
                <select id="select21" class="form-control select2 no-border">
                    <option v-for="(industry_obj, industry) in industryList" :value="JSON.stringify(industry_obj)">{{industry_obj.indt_NM}}</option>
                </select>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="1" @click="showFormData">
        </b-col>
      </b-row>
    </div>
  </b-card>
  <b-modal title="광고주 검색" size="lg" v-model="advertigerModal" @ok="advertigerModal = false">
    <div>
      <b-input-group>
        <input v-model="search_avdt_nm" class="form-control" style="margin-left:5px;" type="text" placeholder="광고주 검색" @keyup.enter="findAdvertiger()"></input>
        <b-input-group-append>
          <b-button style="margin-left:5px;" variant="primary" @click="findAdvertiger()"><i class="fa fa-search"></i> 검색</b-button>
          <b-button style="margin-left:5px;" variant="secondary" @click="advertigerModal = false">취소</b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div class="">
      <br />
      <b>위 검색어에 대한 결과 총 {{advertigerList.length}}건 검색 완료</b>
      <br />
      <br />
    </div>
    <div class="searched-block panelScrollBar" style="overflow-y: auto;overflow-x: hidden;">
      <div style="max-height:200px;">
        <b-button v-for="item in advertigerList" v-bind:key="item.advt_CD" variant="outline-primary" @click="selectedADVT(item)" @keyup.enter="selectedADVT(item)">{{item.advt_NM}}</b-button>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="">
        <br />
        <b>최근 검색된 광고주</b>
        <br />
        <br />
      </div>
      <div class="searched-block">
        <b-button v-for="item in local_advertigerList" v-bind:key="item.advt_CD" variant="outline-success" @click="selectedADVT(item)" @keyup.enter="selectedADVT(item)">{{item.advt_NM}}</b-button>
      </div>
    </div>
  </b-modal>

  <b-modal title="대행사 검색" size="lg" v-model="agencyModal" @ok="agencyModal = false">
    <div>
      <b-input-group>
        <input v-model="search_agc_nm" class="form-control" style="margin-left:5px;" type="text" placeholder="대행사 검색" @keyup.enter="findAgency()"></input>
        <b-input-group-append>
          <b-button style="margin-left:5px;" variant="primary" @click="findAgency()"><i class="fa fa-search"></i> 검색</b-button>
          <b-button style="margin-left:5px;" variant="secondary" @click="agencyModal = false">취소</b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div class="">
      <br />
      <b>위 검색어에 대한 결과 총 {{agencyList.length}}건 검색 완료</b>
      <br />
      <br />
    </div>
    <div class="searched-block panelScrollBar" style="overflow-y: auto;overflow-x: hidden;">
      <div style="max-height:200px;">
        <b-button v-for="item in agencyList" v-bind:key="item.agc_CD" variant="outline-primary" @click="selectedAGC(item)" @keyup.enter="selectedAGC(item)">{{item.agc_NM}}</b-button>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="">
        <br />
        <b>최근 검색된 대행사</b>
        <br />
        <br />
      </div>
      <div class="searched-block">
        <b-button v-for="item in local_agencyList" v-bind:key="item.agc_CD" variant="outline-success" @click="selectedAGC(item)" @keyup.enter="selectedAGC(item)">{{item.agc_NM}}</b-button>
      </div>
    </div>
  </b-modal>
  <!--[end] 캠페인 기본 정보 입력 -->
  <!--[start] 매체계획 입력-->
  <b-card style="height:550px" class="bs-callout bs-callout-primary panelScrollBar">
    <div style="min-width: 1200px;">
      <b-row style="padding-bottom:35px;">
        <b-col sm="3" sytle="padding-right:0px;">
          <span class="float-left card-title wise-card-title" >2. 매체 계획(미디어 믹스)입력</span>
          <reachHelpForm01></reachHelpForm01>
        </b-col>
        <!-- <b-col sm="1">

        </b-col> -->
        <b-col sm="8">
          <!-- <span class="small text-muted wise-card-subtitle"> 캠페인의 세부 <b>미디어 믹스</b>를 입력하세요.</span> -->
          <span class="float-right" style="padding-right:20px;">
            <b-button block variant="outline-primary" class="btn-pill" @click="addMedia();changeRootIndex(500)">
              <span style="font-weight:900;">매체 추가</span>
            </b-button>
          </span>
          <span class="float-right " style="padding-right:20px;">
            <b-row>
              <b-col sm="5" class="wise-small-header wise-small-header2 " style="">Output타겟</b-col>
              <b-col sm="5" style="padding-left:0px;padding-right:0px;" v-on:click="outputTargetModal = true">
                <b-form-input :state="true" class="btn-pill" v-model="formData.genderLabel" type="text" placeholder="타겟선택" v-on:focus="outputTargetModal = true"></b-form-input>
              </b-col>
              <b-col sm="2" style="padding-left:8px;">
              <reachHelpForm03></reachHelpForm03>
              </b-col>
            </b-row>
          </span>
          <reachHelpForm02></reachHelpForm02>
          <span class="float-right" style="padding-right:10px;">
            <b-button block variant="outline-success" class="btn-pill" @click="insertBookMark">
              <span style="font-weight:900;">믹스안 저장</span>
            </b-button>
          </span>
        </b-col>
      </b-row>
      <b-row style="padding-bottom:10px; text-align:center;" class="wise-small-header">
        <b-col sm="4">
          <div>
            <b-row>
              <b-col sm="3">미디어</b-col>
              <b-col sm="4">채널</b-col>
              <b-col sm="5">비히클</b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="1">타겟</b-col>
        <b-col sm="4">
          <b-row>
            <b-col sm="4">예산 (만원)</b-col>
            <b-col sm="4">CPM </b-col>
            <b-col sm="4">E.imp</b-col>
          </b-row>
        </b-col>
        <b-col sm="3">
          <b-row>
            <b-col sm="4">가중치</b-col>
            <b-col sm="5">날짜</b-col>
            <b-col sm="1"></b-col>
            <b-col sm="1"></b-col>
          </b-row>
        </b-col>
      </b-row>
      <div class="panelScrollBar" style="overflow-y:auto;overflow-x:hidden;">
        <div style="max-height:380px;">
          <component v-bind:mediaList="formData.mediaList" v-bind:rootStartDate="formData.startDate"
          v-bind:flagRootIndex="flagRootIndex"
          v-bind:rootEndDate="formData.endDate" v-on:changeRootIndex="changeRootIndex($event)"
          v-on:changeBudget="changeBudget($event)" ref="mediaListRef" v-for="item in componentsMediaList"
          v-bind:key="item.id" :is="item">
          </component>
        </div>
      </div>
    </div>
  </b-card>
  <!--[end] 매체계획 입력-->
  <!--[Start] Output 타겟 입력 -->
  <b-modal title="Output 타겟 설정" size="lg" v-model="outputTargetModal" @ok="outputTargetModal = false">
    <reachTarget v-bind:formData="formData" ref="reachTargetRef"></reachTarget>
  </b-modal>
  <!--[End] Output 타겟 입력 -->
  <div style="padding-bottom:20px;">
    <div style="background-color:white; border-left: 2px solid #428bca;">
      <b-button block variant="outline-primary" style="border:1px solid #c2cfd6;border-left: 0px;" v-on:click="goResult(false)">
        <span style="font-weight:900;">GO 리치 시뮬레이션 → </span>
      </b-button>
    </div>
  </div>
  <b-card style="height:110px" class="bs-callout bs-callout-primary panelScrollBar">
    <div style="min-width: 1200px;font-weight:bold">
      * 본 솔루션에서 제공되는 분석결과는 닐슨 3스크린 싱글소스 데이터 및 각 매체사에서 제공되는 실집행 데이터를 기반으로 하며, 매체별 특성을 반영한 평균적인 예측모델을 기준으로 합니다. <br />
      * 즉, 실제 집행과정에서 여러가지 조건들이 전제되는 경우는 본 시스템의 예측영역 밖이며, 이로인해 오차가 크게 발생할 수 있습니다. <br />
      * 또한, 본 시스템의 예측결과는 실제 결과를 보장하지 않으며, 보수적 관점의 예측로직 활용으로 인해 실제 결과보다 낮은 경향의 수치를 제공합니다
    </div>
  </b-card>
</div>
</template>

<script>
const moment = require("moment");
import swal from 'sweetalert2'

import datetimepicker from "daterangepicker/daterangepicker.js";
import select2 from "select2/dist/js/select2.full.min.js";

import Vue from 'vue';
import VueResize from 'vue-resize';
Vue.use(VueResize);

import MediaTemplate from "./MediaTemplate";

import modelFormData from "../../common/ModelFormData.js";

import reachFormData from "../../common/ReachFormData.js";
import ReachUtils from "../../common/ReachUtils.js";
import reachTarget from "../../common/reachTarget.vue" // 타겟 선택 컴포넌트
import WeightDB from "../../common/WeightDB.js";

import leftSideUtil from "../../common/LeftSideUtil.js"

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import targetPortionUtils from "../../common/targetPortionUtils.js";

import numeral from 'numeral';
import reachHelpForm01 from "../../helpModals/reach/reachHelpForm01.vue";
import reachHelpForm02 from "../../helpModals/reach/reachHelpForm02.vue";
import reachHelpForm03 from "../../helpModals/reach/reachHelpForm03.vue";

export default {
  filters:{
    thousands : function (value) {
      return numeral(value).format('0,0');
    }
  },
  // DateRangePicker
  components: {
    MediaTemplate,
    reachHelpForm01,
    reachHelpForm02,
    reachHelpForm03,
    reachTarget
  },
  data() {
    return {
      screens: modelFormData.ScreenMediaStructure,
      mediaSize:1,
      hideFooter: true,
      historyDataMedia : null,
      resultInterval:null,
      id: '', // 주석 달기
      name: '',
      formData: this.$_.clone(reachFormData.formData),
      historyData : this.$_.clone(reachFormData.historyData),
      advertigerModal: false,
      advertigerName: '',
      agencyModal: false,
      agencyName: '',
      selected_indt: null,
      //advertiger: '',
      search_avdt_nm: '',
      advertigerList: [],
      local_advertigerList: [],
      //agency: '',
      search_agc_nm: '',
      agencyList: [],
      local_agencyList: [],
      industryList: [],
      ////////////////////////////////////////
      componentsMediaList: [],
      mediaCNT: 0,
      queryData: {
        media: "전체",
        channel: "전체",
        vehicle: "전체"
      },
      channels: [],
      vehicles: [],
      outputTargetModal: false,
      // validateCheck: false,
      mediaBudgetSum: 0,
      flagRootIndex:false,
    }
  },
  beforeCreate: function() {},
  watch: {
    'componentsMediaList': function() {
      // var keylist = Object.keys(this.formData.mediaList);
    },
    'formData.totalBudget': function() {
      this.formData.totalBudgetStr = numeral(this.formData.totalBudget).format('0,0');
    }
  },
  mounted: function() {
    this.getScreenChannel('VA', 'TV');
    this.getScreenChannel('VA', 'PC');
    this.getScreenChannel('VA', 'Mobile');
    this.getScreenChannel('VA', 'Digital');
    this.getScreenChannel('DA', 'Digital')
    this.getScreenChannel('DA', 'PC');
    this.getScreenChannel('DA', 'Mobile');

    leftSideUtil.highLightMenu('reachDACustomId8642');

    this.$http.get('/select/demographics')
      .then((result) => {
        this.$session.set('demographics', result.data);
    })

    this.findIndustry();
    if (localStorage.local_advertigerList == null || localStorage.local_advertigerList == '') {} else {
      this.local_advertigerList = JSON.parse(localStorage.local_advertigerList);
    };
    if (localStorage.local_agencyList == null || localStorage.local_agencyList == '') {} else {
      this.local_agencyList = JSON.parse(localStorage.local_agencyList);
    };
    this.createSelectFn(this);

    // formData 날짜값 초기화
    this.formData.startDate = moment().format('YY/MM/DD'),
    this.formData.endDate = moment().add(30, 'days').format('YY/MM/DD')

    // 항상 가장 마지막에 실행되야함
    var query = this.$route.query.status;
    var historyformData = null;
    var historyformData2 = null;
    if(query != 'new'){
      historyformData = this.$session.get('inputFormData'); // test 2018-07-25
    }else{
    }
    if ( historyformData !== null && historyformData !== undefined ){
      var industry = this.$_.clone(historyformData.industry);

      this.formData = historyformData; // 위치에 의미가 있음 , outputTart이 의도랑 다르게 바뀌게 될수도 있음
      this.advertigerName = historyformData.advertiger.advt_NM;
      this.agencyName = historyformData.agency.agc_NM;
      this.createCalendar(true);
      var self = this;
      setTimeout(function(){
        var optionCD = industry.indt_CD.substring(4,7);
        optionCD = parseInt(optionCD) - 1;

        var selectOption = '#select21 option:eq(' + optionCD + ')';
        $('#select21 option:eq(0)')[0].selected = false;
        $(selectOption)[0].selected = true;
        self.createSelectFn(self);
        self.$refs.reachTargetRef.historyTarget(); // 즐겨찾기에 저장된 연령대 선택
      }, 1000); // 1초후 실행
      var mediaListResult = historyformData.mediaListResult;
      for(var i=0; i<mediaListResult.length; i++){
       this.historyDataMedia = mediaListResult[i]; // 이게 무슨 의미?
       this.addMedia();
      }
      var self = this;
      setTimeout(function(){
        var refLen = self.$refs.mediaListRef.length;
        // step1
        for (var i = 0; i < refLen; i++) {
          self.$refs.mediaListRef[i].mediaInfo = mediaListResult[i];
          self.$refs.mediaListRef[i].mediaInfoHistory = self.$_.clone(mediaListResult[i]);
        }
        var keylist = Object.keys(self.formData.mediaList);

        for (var i = 0; i < keylist.length; i++) { // 이게 왜 있는거지? 위에 코드랑 무슨차이?
          var key = keylist[i];
          // self.formData.mediaList[key] = self.$_.clone(mediaListResult[i]);
          self.formData.mediaList[key] = mediaListResult[i];
        }

        for (var i = 0; i < refLen; i++) {
          self.$refs.mediaListRef[i].setSelectBoxbyHistory();
          // self.$refs.mediaListRef[i].selectInit();
        }
      }, 1000);
    }else{
      this.$refs.reachTargetRef.demographicCount(); // 즐겨찾기 아닌경우, 신규타겟
      this.addMedia();
    }
    this.changeRootIndex(1500);
  },
  created: function() {
    this.id = this._uid + "_";

    this.formData.mediaList = new Array(); // 주석달기
    this.createCalendar(false);

  },
  updated: function() {
  },
  methods: {
    getScreenChannel(type, media) {
      var user_id = this.$session.get('email');
      this.$http.get('/select/screenchannel?type=' + type + '&media=' + media)
        .then((result) => {
          for(var i=0; i<result.data.length; i++){
              this.screens[type][media][result.data[i].channel] = [];
              this.$http.get('/select/screenvehicle?type=' + type + '&media=' + media + '&channel=' + result.data[i].channel + '&user_id='+user_id)
                .then((resultV) => {
                  this.screens[type][media][resultV.data[0].channel] = resultV.data;
              })
          }
        })
    },
    createCalendar(history){
      var formData = this.formData;
      if(!history){
        $(function() {
          $('input[name="daterange"]').daterangepicker({
            opens: 'left',
            "locale": reachFormData.calendarLocale,
            "startDate": moment().format('YY/MM/DD'),
            "endDate": moment().add(30, 'days').format('YY/MM/DD')
          }, function(start, end, label) {
            formData.startDate = start.format('YY/MM/DD');
            formData.endDate = end.format('YY/MM/DD');
          });
        });
      }else if(history){
        $(function() {
          $('input[name="daterange"]').daterangepicker({
            opens: 'left',
            "locale": reachFormData.calendarLocale,
            "startDate": formData.startDate,
            "endDate": formData.endDate
          }, function(start, end, label) {
            formData.startDate = start.format('YY/MM/DD');
            formData.endDate = end.format('YY/MM/DD');
          });
        });
      }
    },
    format_thousands(value){
      return numeral(value).format('0,0');
    },
    handleResize() {
      this.createSelectFn(this);
    },
    createSelectFn(vm) {
      $("#select21").select2({
        theme: "bootstrap",
        placeholder: "업종을 선택하세요",
        "border-color": "red",
        // minimumResultsForSearch: -1
      }).on('change', function() {
        if(this.value !== ''){
          vm.$data.formData.industry = JSON.parse(this.value);
        }
      });
    }, // end createSelectFn
    findAdvertiger() {
      var param = "?advt_nm=" + this.search_avdt_nm;
      this.$http.get('/select/advertiger' + param)
        .then((result) => {
          this.advertigerList = result.data;
        })
    },
    selectedADVT(advt) {
      this.formData.advertiger = advt;
      this.advertigerName = advt.advt_NM;
      var push = true;
      // this.local_advertigerList = [];
      for (var i = 0; i < this.local_advertigerList.length; i++) {
        if (advt.advt_CD == this.local_advertigerList[i].advt_CD) {
          push = false;
        }
      }
      if (push) {
        this.local_advertigerList.splice(0, 0, advt);
      }

      if (this.local_advertigerList.length > 15) {
        var cnt = this.local_advertigerList.length;
        this.local_advertigerList.splice(15, (cnt - 15));
      }

      localStorage.local_advertigerList = JSON.stringify(this.local_advertigerList);
      this.advertigerModal = false;
    },
    findAgency() {
      var param = "?agc_nm=" + this.search_agc_nm;
      this.$http.get('/select/agency' + param)
        .then((result) => {
          this.agencyList = result.data;
        })
    },
    selectedAGC(agc) {
      this.formData.agency = agc;
      this.agencyName = agc.agc_NM;
      var push = true;
      // this.local_advertigerList = [];
      for (var i = 0; i < this.local_agencyList.length; i++) {
        if (agc.agc_CD == this.local_agencyList[i].agc_CD) {
          push = false;
        }
      }
      if (push) {
        this.local_agencyList.splice(0, 0, agc);
      }

      if (this.local_agencyList.length > 15) {
        var cnt = this.local_agencyList.length;
        this.local_agencyList.splice(15, (cnt - 15));
      }

      localStorage.local_agencyList = JSON.stringify(this.local_agencyList);
      this.agencyModal = false;
    },
    findIndustry() {
      this.$http.get('/select/industry')
        .then((result) => {
          this.industryList = result.data;
          this.formData.industry = this.industryList[0];
        })
    },
    addMedia() {
      //var child = this.makeMedia('MediaTemplate');
      this.componentsMediaList.push(this.makeMedia());
      var self = this;
    },
    changeRootIndex(second){
      // 매채 계획에 번호 부여하는 로직
      var self = this;
      setTimeout(function(){
        var keylist = Object.keys(self.formData.mediaList);
        self.mediaSize = keylist.length;
        for (var i = 0; i < keylist.length; i++) {
          var key = keylist[i];
          self.formData.mediaList[key].rootIndex = (i+1)
        }
        self.flagRootIndex = !self.flagRootIndex;
      }, second);
    },
    makeMedia() {
      return Vue.component('MediaTemplate', MediaTemplate);
    },
    changeBudget(value) {
      this.formData.totalBudget = 0;
      var keylist = Object.keys(this.formData.mediaList);
      for (var i = 0; i < keylist.length; i++) {
        var key = keylist[i];
        this.formData.totalBudget += parseInt(this.formData.mediaList[key].budget);
      }
    },
    showFormData() {
      var keylist = Object.keys(this.formData.mediaList);
      for (var i = 0; i < keylist.length; i++) {
        var key = keylist[i];
      }
    },
    insertBookMark(){
      this.goResult(true);
    },
    goResult(insertBookMark) {

      // DA 모델의 채널에는 전체의 개념은 없음
      var keylist = Object.keys(this.formData.mediaList);
      for (var i = 0; i < keylist.length; i++) {
        var key = keylist[i];
        if(this.formData.mediaList[key].channel == '전체'){
          swal({
            type: 'error',
            text: '채널을 선택하여 주세요'
          }).then((result) => {
            this.backtoForm();
          })
          return;
        }
      }

      // this.validateCheck = !this.validateCheck;
      var refLen = this.$refs.mediaListRef.length;
      // step1
      for (var i = 0; i < refLen; i++) {
        this.$refs.mediaListRef[i].validationFinish = false;
        this.$refs.mediaListRef[i].validateCheckFN();
      }
      // step3
      this.$validator.validateAll().then(res => {
        if (res) {
          var mediaList = [];
          var finalResult = true;
          var keylist = Object.keys(this.formData.mediaList);

          var self = this;
          var cnt = 0;
          clearInterval(this.resultInterval);
          var resultInterval = this.resultInterval;

          resultInterval = setInterval(function() {
            for (var i = 0; i < keylist.length; i++) {
              var key = keylist[i];
              finalResult = finalResult && self.formData.mediaList[key].formValidation;
              mediaList.push(self.formData.mediaList[key]);
            }
            self.formData.mediaListResult = mediaList;
            if (finalResult) {
              clearInterval(resultInterval);
              self.$session.set('inputFormData', self.formData); // 이부분은 없애도 될듯
              if(insertBookMark){
                self.insertHistoryData();
                swal({
                  position: 'top-end',
                  type: 'success',
                  title: '믹스안을 저장하였습니다.',
                  showConfirmButton: false,
                  timer: 1500
                })
                setTimeout(function(){
                  sessionStorage.setItem("bookMarkReload", "insert");
                }, 500);
              }else{ // 결과 화면으로 넘어가는 로직
                //////////////////////////////////////////////////////////////////////////////////////////////////////////////
                for(var i=0; i<self.formData.mediaListResult.length; i++){
                  self.formData.mediaListResult[i].grps = ((self.formData.mediaListResult[i].eImp / self.formData.mediaListResult[i].demographic_cnt) * 100).toFixed(2);
                  self.formData.mediaListResult[i].target = self.formData.mediaListResult[i].targetCode;
                }

                var token = sessionStorage.getItem("myToken");
                var param = encodeURI(JSON.stringify(self.formData.mediaListResult));
                var data = new FormData();
                data.append('objs', param);

                self.$http.post('/api/select/cffcntData?access_token='+token, data, null)
                  .then((result) => {
                    self.$log.debug('[가중치 적용 로직] 시작 여기다 넣을까...');
                    for(var i=0; i <result.data.length; i++){
                      // [start] 가중치 적용로ㅈㄱ
                      if(self.formData.mediaListResult[i].vehicle_type == 'system'){
                        self.formData.mediaListResult[i].eImp = self.formData.mediaListResult[i].eImp * result.data[i].wght
                        self.formData.mediaListResult[i].eImpStr = numeral(self.formData.mediaListResult[i].eImp).format('0,0');
                      }else{
                        // 모델커스텀이므로 일단 가중치 부터 계산
                        var initWGT = WeightDB.data.initvalue.weight;
                        var pcWGT = WeightDB.data.device.pcWeight;
                        var pcStatic = parseInt(WeightDB.data.device.pcStatic);
                        var moWGT = WeightDB.data.device.moWeigth;
                        var moStatic = WeightDB.data.device.moStatic;
                        var bannerHeight = self.formData.mediaListResult[i].bannerHeightStr;
                        var bannerWidth =  self.formData.mediaListResult[i].bannerWidthStr;
                        var bannerSize = parseInt(bannerHeight) * parseInt(bannerWidth) ;
                        var bannerWGT = WeightDB.data.banner[self.formData.mediaListResult[i].optionASelected];
                        var sitePosition1 = WeightDB.data.sitePosition1[self.formData.mediaListResult[i].optionBSelected];
                        var sitePosition2 = WeightDB.data.sitePosition2[self.formData.mediaListResult[i].optionCSelected];
                        var movement = WeightDB.data.movement[self.formData.mediaListResult[i].optionDSelected];
                        var mediaType = WeightDB.data.mediaType[self.formData.mediaListResult[i].optionESelected];

                        if(self.formData.mediaListResult[i].media == 'Digital'){
                          // var bannerSizeWGTPC = ( Math.log(
                          //                         ( bannerSize / pcStatic)
                          //                         /
                          //                         ( 1- ( bannerSize / pcStatic) )
                          //                       ) + 8
                          //                     ) / 8;
                          // var finalWGTPC = initWGT * pcWGT * bannerWGT * sitePosition1 * sitePosition2 * movement * mediaType * bannerSizeWGTPC ;
                          //
                          // var bannerSizeWGTMO = ( Math.log(
                          //                         ( bannerSize / moStatic)
                          //                         /
                          //                         ( 1- ( bannerSize / moStatic) )
                          //                       ) + 8
                          //                     ) / 8;
                          // var finalWGTMO = initWGT * moWGT * bannerWGT * sitePosition1 * sitePosition2 * movement * mediaType * bannerSizeWGTMO ;
                          //
                          // var finalWGT = (finalWGTPC + finalWGTMO) / 2;
                          // self.formData.mediaListResult[i].eImp = self.formData.mediaListResult[i].eImp * finalWGT;
                          // self.formData.mediaListResult[i].eImpStr = numeral(self.formData.mediaListResult[i].eImp).format('0,0');

                        }else if(self.formData.mediaListResult[i].media == 'PC'){
                          var bannerSizeWGT = ( Math.log(
                                                  ( bannerSize / pcStatic)
                                                  /
                                                  ( 1- ( bannerSize / pcStatic) )
                                                ) + 8
                                              ) / 8;
                          var finalWGT = initWGT * pcWGT * bannerWGT * sitePosition1 * sitePosition2 * movement * mediaType * bannerSizeWGT ;

                          self.formData.mediaListResult[i].eImp = self.formData.mediaListResult[i].eImp * finalWGT;
                          self.formData.mediaListResult[i].eImpStr = numeral(self.formData.mediaListResult[i].eImp).format('0,0');
                        }else if(self.formData.mediaListResult[i].media == 'Mobile'){
                          var bannerSizeWGT = ( Math.log(
                                                  ( bannerSize / moStatic)
                                                  /
                                                  ( 1- ( bannerSize / moStatic) )
                                                ) + 8
                                              ) / 8;
                          var finalWGT = initWGT * moWGT * bannerWGT * sitePosition1 * sitePosition2 * movement * mediaType * bannerSizeWGT ;

                          self.formData.mediaListResult[i].eImp = self.formData.mediaListResult[i].eImp * finalWGT;
                          self.formData.mediaListResult[i].eImpStr = numeral(self.formData.mediaListResult[i].eImp).format('0,0');
                        }

                      }
                    }
                    self.$log.debug('[가중치 적용 로직]');

                    self.$log.debug('[타겟 배분비율 로직] 시작');
                    var ageCntList = new Map();
                    targetPortionUtils.getSplit5AgeList(ageCntList);
                    var portionList = new Map();
                    targetPortionUtils.getTargetPortionList(portionList);
                    // 아웃풋 타겟 쪽 배분비율 계산
                    var outputAge = self.formData.age;
                    var outputGender = self.formData.gender;
                    var outputAgeCode = ageCntList.get(outputAge);
                    self.formData.outputAgeCode = outputAgeCode;
                    self.$log.debug('[타겟 배분비율 로직] 아웃풋타겟 : ', outputGender, outputAge);
                    for(var i=0; i<self.formData.mediaListResult.length; i++){
                      // GRPs = (E.Imp / 타겟모수) * 100
                      var inputAge = self.formData.mediaListResult[i].age;
                      self.formData.mediaListResult[i].inputAgeCode = ageCntList.get(inputAge);

                      var inputGender = self.formData.mediaListResult[i].gender;
                      var channel = self.formData.mediaListResult[i].channel;
                      if(channel != 'Facebook' && channel != 'Youtube' && channel != 'SMR' ){
                        channel = self.formData.mediaListResult[i].media;
                      }
                      var channelGender = channel + '_' + inputGender;
                      var inputPortionList = portionList.get(channelGender);
                      var portionSum = 0.00;

                      var inputAgeCode = self.formData.mediaListResult[i].inputAgeCode;
                      var intersectedCode = [];
                      for(var j=0; j< inputAgeCode.length; j++){
                        if(inputAgeCode[j] == 1){
                          portionSum += inputPortionList[j].portion;
                        }
                        if(inputAgeCode[j]&&outputAgeCode[j]){
                          intersectedCode[j] = 1;
                        }else{
                          intersectedCode[j] = 0;
                        }
                      }
                      self.formData.mediaListResult[i].portionSum = portionSum;
                      self.formData.mediaListResult[i].intersectedCode = intersectedCode;

                      if(outputGender == inputGender){
                        var tmpChannelGender = channel + '_' + outputGender;
                        self.calcOutputImpression(self.formData.mediaListResult[i], tmpChannelGender, portionList);
                      }else if(outputGender == 'MF'){
                        // inputTarget의 Gender 활용
                        var tmpChannelGender = channel + '_' + inputGender;
                        self.calcOutputImpression(self.formData.mediaListResult[i], tmpChannelGender, portionList);
                      }else if(inputGender == 'MF'){
                        // outputTarget의 Gender 활용
                        var tmpChannelGender = channel + '_' + outputGender;
                        self.calcOutputImpression(self.formData.mediaListResult[i], tmpChannelGender, portionList);
                      }else {
                        // inputTarget과 outputTarget의 성별이 다른경우
                        self.formData.mediaListResult[i].outputPortionSum = 0;
                        self.formData.mediaListResult[i].outputImpression = 0;
                      }
                      // input 성별 output성별 비교 해서 outputTarget의 배분비율 결정
                      self.$log.debug('[타겟 배분비율 로직] 인풋타겟 : ', channelGender,
                      inputAge, self.formData.mediaListResult[i].eImp, self.formData.mediaListResult[i].outputImpression);
                    }
                    self.$log.debug('[타겟 배분비율 로직] 종료');
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    self.$session.set('inputFormData', self.formData);
                    window.location.href = "#/reach/da/result";

                });
              }
            }
            cnt++;
            clearInterval(resultInterval);
          }, 1000);

          this.resultInterval = resultInterval;

        } else {
          var keylist = Object.keys(this.formData.mediaList);
          for (var i = 0; i < keylist.length; i++) {
            var key = keylist[i];
          }
        }
      })
    },
    calcOutputImpression(mediaResult, tmpChannelGender, portionList){
      var outputPortionSum = 0.0;
      var outputPortionList = portionList.get(tmpChannelGender);
      var intersectedCode = mediaResult.intersectedCode;
      for(var j=0; j< intersectedCode.length; j++){
        if(intersectedCode[j] == 1){
          outputPortionSum += outputPortionList[j].portion;
        }
      }
      mediaResult.outputPortionSum = outputPortionSum;
      // outputImpression 계산 : (e.Impression * outputPortion / inputPortion)
      mediaResult.outputImpression = parseInt(
        parseFloat(mediaResult.eImp) * outputPortionSum / mediaResult.portionSum
      )
      mediaResult.outputImpressionStr = numeral(mediaResult.outputImpression).format('0,0');
    },
    insertHistoryData() {

      this.historyData.user_id = this.$session.get('email');
      this.historyData.std_dt = moment().format('YYYY-MM-DD HH:mm');
      this.historyData.view_cd = 'reachSimulationDA';
      this.historyData.view_name = '리치시뮬레이션(DA)';
      this.historyData.formData = JSON.stringify(this.formData);
      this.historyData.css = "success";
      // self.historyData.bookMarked = self.formData;

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.historyData));

      var data = new FormData();
      data.append('objs', param);
      var config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      this.$http.post('/api/insert/history?access_token='+token, data,config)
        .then((result) => {

        })
    },
  }
}
</script>

<style src="daterangepicker/daterangepicker.css"></style>
<style src="select2/dist/css/select2.min.css"></style>
<style src="select2-bootstrap-theme/dist/select2-bootstrap.min.css"></style>

<style scoped>
/* [start] output target 입력 */
#genderGroup .btn.active {
  color: #fff;
  border: 1px solid #428bca !important;
}

#ageGroup .btn.active {
  color: #fff;
  border: 1px solid #049372 !important;
}

.btn-age-group-lg {
  width: 234px;
  margin-right: 11px;
  font-weight: 600;
}

.btn-age-group-sm {
  width: 65px;
  margin-right: 5px;
  margin-bottom: 3px;
  font-weight: 600;
}

/* [end] output target 입력 */
</style>

<style>
select.error+.select2-container--bootstrap .select2-selection--single {
  color: #9F3A38 !important;
  background-color: #FFF6F6 !important;
  border-color: #E0B4B4 !important;
}

input.error {
  color: #9F3A38 !important;
  background-color: #FFF6F6 !important;
  border-color: #E0B4B4;
}
</style>



// WEBPACK FOOTER //
// src/views/reach/da/Reach.vue